import PropTypes from 'prop-types';
import React, { Component } from 'react';
import RUNNING_BG from './images/blu_cannuccia.png';
import FINAL_BG from './images/congratulations.png';
import './styles.css';

class Body extends Component {
	render() {
		const { children, game } = this.props;

		return <div className={`main-layout-body ${game.state}`}
			style={{
				backgroundImage: game.state === 'COMPLETED' ? `url('${FINAL_BG}')` : `url('${RUNNING_BG}')`
			}}>{children}</div>;
	}
}
Body.propTypes = {
	children: PropTypes.node
};

export default Body;
